import { useState } from "react";
import ButtonExpandContent from "./ButtonExpandContent";
import ExpandContent from "./ExpandContent";

export interface FeatureItem {
  title: string; // Naslov (npr. "Gorivo")
  value: string; // Vrijednost (npr. "Dizel")
}

export interface FeatureProps {
  title: string;
  items: FeatureItem[]; // Niz objekata s naslovima i vrijednostima
  initiallyOpened: boolean; // Početno stanje proširenosti
  children?: React.ReactNode; // Dodatni sadržaj koji se može proslijediti
}

export function Feature(props: FeatureProps) {
  const { title, items, initiallyOpened, children } = props;
  const [open, setOpen] = useState<boolean>(initiallyOpened);

  function toggleOpen() {
    setOpen((prev) => !prev);
  }

  // Automatsko filtriranje i prilagodba stavki
  const filteredItems = items
    .map((item) => {
      // Generalno filtriranje praznih vrijednosti
      if (item.value && item.value !== "" && item.value !== "-") {
        return item;
      }

      return null; // Izostavlja stavke koje ne zadovoljavaju uvjete
    })
    .filter((item) => item !== null) as FeatureItem[]; // Uklanja null vrijednosti

  return (
    <>
      <ButtonExpandContent onClick={toggleOpen} open={open} title={title}>
        {children}
      </ButtonExpandContent>

      {/* Animation of toggle */}
      <ExpandContent open={open}>
        <div className="flex flex-col border rounded border-extra-light">
          {filteredItems.map((item, index) => (
            <div
              key={index}
              className={`flex ${index % 2 === 0 ? "bg-gray-bg" : ""}`}
            >
              <div className="w-1/2 px-4 py-4 gap-[10px] font-medium text-[13px] text-gray-extra-dark text-opacity-80">
                {item.title}
              </div>
              <div className="w-1/2 px-4 py-4 gap-[10px] text-[13px] text-gray-extra-dark text-opacity-80">
                {item.value}
              </div>
            </div>
          ))}
        </div>
      </ExpandContent>
    </>
  );
}

export default Feature;
